// src/pages/demos.tsx
import React from "react";
import LoginLayout from "core/onboard/UI/LoginLayout";
import OnboardRequestDemoReskinned from "core/onboard/UI/OnboardRequestDemoReskinned";

export async function getServerSideProps() {
  return { props: {} };
}

export default function RequestDemo() {
  return (
    <LoginLayout>
      <OnboardRequestDemoReskinned />
    </LoginLayout>
  );
}
